import { HttpClient ,HttpParams} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { UserBalanceResponse } from "src/app/interfaces/responses/models";
import { AddUserTokensResponse } from "src/app/interfaces/responses/models";
import { TransactionResponse } from "src/app/interfaces/responses/models";
export interface TransactionItem {
  id: string;
  transaction_type: string;
  amount: string;
  status: string;
  reference?: string;
  created_on?: string;
  modified_on?: string;
}

export interface TransactionListResponse {
  transactions: TransactionItem[];
  total_items: number;
  total_pages: number;
  current_page: number;
}

@Injectable({
  providedIn: "root",
})
export class PaymentService {

  private readonly apiUrl = environment.apiUrl + "payment/transactions/";

  private readonly paymentBase = environment.apiUrl + "payment/";

  constructor(private http: HttpClient) {}

  private createCompleteUrl(path: string): string {
    return `${this.apiUrl}${path}`;
  }

  private createPaymentUrl(path: string): string {
    return `${this.paymentBase}${path}`;
  }



  getWalletBalance(): Observable<UserBalanceResponse> {
    return this.http.get<UserBalanceResponse>(
      this.createCompleteUrl("balance")
    );
  }

  addTokens(payload: {
    amount: number;
    payment_method: string;
    device: string;
  }): Observable<AddUserTokensResponse> {
    return this.http.post<AddUserTokensResponse>(
      this.createCompleteUrl("start-intent"),
      payload
    );
  }

 getTransactions(params?: {
    status?: string | null;
    transaction_type?: string | null;
    start_time?: string | null;
    amount?: number | null;
    limit?: number | null;
    offset?: number | null;
  }): Observable<TransactionListResponse> {
    let httpParams = new HttpParams();
    if (params) {
      if (params.status != null) httpParams = httpParams.set("status", String(params.status));
      if (params.transaction_type != null)
        httpParams = httpParams.set("transaction_type", String(params.transaction_type));
      if (params.start_time != null) httpParams = httpParams.set("start_time", String(params.start_time));
      if (params.amount != null) httpParams = httpParams.set("amount", String(params.amount));
      if (params.limit != null) httpParams = httpParams.set("limit", String(params.limit));
      if (params.offset != null) httpParams = httpParams.set("offset", String(params.offset));
    }

    return this.http.get<TransactionListResponse>(this.apiUrl, { params: httpParams });
  }

  validateBalance(params: {
    bid_price: number | string;
    energy_amount: number | string;
    transaction_type_id: number;
    bid_id?: string | null;
  }): Observable<{ status: boolean; required_balance: string }> {
    return this.http.get<{ status: boolean; required_balance: string }>(
      this.createCompleteUrl("validate-balance"),
      { params: params as any }
    );
  }


  getWalletInfo(): Observable<any> {
    const url = this.createPaymentUrl("wallet");
    return this.http.get<any>(url);
  }


  initiatePayout(payload: { amount: number; payee_vpa: string; remark: string }): Observable<any> {
    const url = this.createCompleteUrl("redeem");
    return this.http.post<any>(url, payload);
  }
}
